import { IFontStyles, IPartialTheme, IRawStyle, loadTheme } from '@fluentui/react/lib/Styling';

export const SalusThemeKey = 'salus-theme';

export const isDarkTheme = (): boolean => {
  return localStorage.getItem(SalusThemeKey) === 'dark';
};

// We use these 'static' colors in the case when we don't want color to change between light mode and dark mode.
const NeutralDarkStatic = '#201f1e';
export const WhiteStatic = '#ffffff';

const Fonts: Partial<IFontStyles> = {
  xSmall: {
    fontSize: '10px',
    lineHeight: '14px',
    fontFamily: 'Segoe UI, sans-serif'
  },
  small: {
    fontSize: '12px',
    lineHeight: '16px',
    fontFamily: 'Segoe UI, sans-serif'
  },
  medium: {
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'Segoe UI, sans-serif'
  },
  mediumPlus: {
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'BahnschriftStaticSemibold, sans-serif'
  },
  large: {
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: 'BahnschriftStaticSemibold, sans-serif'
  },
  xLarge: {
    fontSize: '18px',
    lineHeight: '24px',
    fontFamily: 'BahnschriftStaticSemibold, sans-serif'
  },
  xLargePlus: {
    fontSize: '20px',
    lineHeight: '28px',
    fontFamily: 'BahnschriftStaticSemibold, sans-serif'
  },
  xxLarge: {
    fontSize: '24px',
    lineHeight: '32px',
    fontFamily: 'BahnschriftStaticSemibold, sans-serif'
  },
  xxLargePlus: {
    fontSize: '28px',
    lineHeight: '36px',
    fontFamily: 'BahnschriftStaticSemibold, sans-serif'
  },
  superLarge: {
    fontSize: '32px',
    lineHeight: '40px',
    fontFamily: 'BahnschriftStaticSemibold, sans-serif'
  },
  mega: {
    fontSize: '42px',
    lineHeight: '52px',
    fontFamily: 'BahnschriftStaticLight, sans-serif'
  }
};

const FontStyle: IRawStyle = { fontFamily: 'Noto Sans, sans-serif', fontWeight: 'normal' };

const ThemeColors = {
  themePrimary: '#008575',
  themeLighterAlt: '#f0faf9',
  themeLighter: '#c6ebe7',
  themeLight: '#99dad3',
  // These are the original colors generated by the theme tool
  // themeTertiary: '#49b6a9',
  themeTertiary: '#008b7a',
  themeSecondary: '#129384',
  themeDarkAlt: '#007769',
  themeDark: '#006559',
  themeDarker: '#004a42'
};

const LightTheme: IPartialTheme = {
  defaultFontStyle: FontStyle,
  fonts: Fonts,
  palette: {
    ...ThemeColors,
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: NeutralDarkStatic,
    black: '#000000',
    white: WhiteStatic
  }
};

const DarkTheme: IPartialTheme = {
  defaultFontStyle: FontStyle,
  fonts: Fonts,
  palette: {
    ...ThemeColors,
    // These are the original colors generated by the theme tool
    // neutralLighterAlt: '#0b0b0b',
    neutralLighterAlt: '#000000',
    neutralLighter: '#151515',
    neutralLight: '#252525',
    neutralQuaternaryAlt: '#2f2f2f',
    neutralQuaternary: '#373737',
    neutralTertiaryAlt: '#595959',
    neutralTertiary: '#595959',
    neutralSecondary: '#f5f4f2',
    neutralPrimaryAlt: '#f7f6f5',
    neutralPrimary: '#edebe9',
    neutralDark: '#fbfafa',
    black: '#fdfdfc',
    // These are the original colors generated by the theme tool
    // white: '#000000'
    white: '#0b0b0b',
    themeDarkAlt: '#008878'
  }
};

export const loadLightTheme = (): void => {
  loadTheme(LightTheme);
};

export const loadDarkTheme = (): void => {
  loadTheme(DarkTheme);
};
